<header>
  <div class="wrap">
    <div class="text">
      <h2 class="title mr-3">{{ title }}</h2>
    </div>
    <div class="header-actions">
      <button class="close" (click)="modalService.close()" title="{{ 'generic.close' | translate }}">
        <span class="icon-view-close" aria-hidden="true">
          <svg>
            <use xlink:href="assets/img/icons.svg#icon-view-close"></use>
          </svg>
        </span>
        <span>{{ 'generic.close' | translate }}</span>
      </button>
    </div>
  </div>
</header>
<div class="main container-fluid">
  <img *ngIf="img" class="rounded mx-auto d-block img-fluid" [src]="img" alt="info-image" />

  <p class="mt-3" style="white-space: pre-line;">{{ description }}</p>

  <footer class="popin-footer mt-3">
    <ng-casto-btn class="blue" [label]="'generic.close' | translate" (click)="modalService.close()"></ng-casto-btn>
  </footer>
</div>